// import { Component, OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Component, ViewChild, AfterViewInit, NgModule, Inject, OnInit, EventEmitter, Output} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import {merge, Observable, of as observableOf} from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatSnackBar} from '@angular/material/snack-bar';
import { AuthenticationService } from '../../_services';
import { first } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { DevolucionService } from '../../_services';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';
interface DevolucionesStatus {
  value: string;
  viewValue: string;
}
@Component({
  selector: 'app-devolucions',
  templateUrl: './devolucions.component.html',
  styleUrls: ['./devolucions.component.scss']
})
export class DevolucionsComponent implements OnInit {
  user: any;
  seller_id: any;
  deshabilitado = false;
  order_id: string;
  selected_tab_dev: number = 0;
  current_user: any;
  devolutionEdit: any = null;
  
  constructor(
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.asignarDatos();
    this.authenticationService.currentUser.subscribe(x => this.user = x);
    if(this.user){
      if(this.user["seller_id"] == 3){
        this.deshabilitado = true;
      }
    }

    this.order_id = this.route.snapshot.queryParams['order_id'] || '/';
    if(this.order_id != null && this.order_id != '' && this.order_id != ' ' && this.order_id != '/'){
        this.selected_tab_dev = 1;
    }else{
        this.selected_tab_dev = 0;
    }
  }
  asignarDatos(){
    this.current_user = this.authenticationService.currentUserValue
    
  }
  validar_roles(clave_modulo){
    return this.authenticationService.validar_roles(clave_modulo,this.current_user.permisos);  
  }

  registerDevolution(){
    this.selected_tab_dev = 0;
  }

  onEdit(event){
    this.devolutionEdit = event;
    this.selected_tab_dev = 2;
  }
  
}

export class DevolucionsDatabase {
  constructor(private _httpClient: HttpClient) {}

  getRepoIssues(sort: string, order: string, page: number, filtro: string, devolucion_status:string, statusGuide = ''): Observable<EntradabApi> {
     const href = `${environment.apiUrl}/rmsfe/query_devoluciones.json`;
    const requestUrl =
        `${href}?sort=${sort}&order=${order}&page=${page + 1}&keywords=${filtro}&estado_devolucion=${devolucion_status}&status_guide=${statusGuide}`;
    return this._httpClient.get<EntradabApi>(requestUrl);
  }
}

@Component({
    selector: 'devolucions-tab-1',
    templateUrl: './devolucions-tab-1.html',
    styleUrls: ['./devolucions.component.scss']
})
export class DevolucionsTab1 implements AfterViewInit {
  
  displayedColumns: string[] = ['entrada_token', 'devolucion_multicanal_id', 'canal', 'shopify_name', 'carrier_name', 'tracking_number', 'estatus', 'status_guia_devolucion', 'fecha_estatus', 'cargar_guia', 'cambiar_status'];
  devolucionsDatabase: DevolucionsDatabase | null;
  data: EntradaIssue[] = [];

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  guiaForm: FormGroup;
  keywords = "";
  hay_datos = true;
  titulo_diff = false;
  datos_iniciales = true;
  on_proces = false;

  devolucion_status: FormControl =  new FormControl('', []);

  statusGuideSelect: FormControl =  new FormControl('', []);

  loading: boolean = false;

  devoluciones_status: DevolucionesStatus[] = [
    {value: 'abierta', viewValue: 'Abierta'},
    {value: 'closed', viewValue: 'Cerrada'},
    {value: 'reabierta', viewValue: 'Re-abierta'},
    {value: 'pausada', viewValue: 'Pausada'},
    {value: 'en_revision', viewValue: 'En revisión'},
    {value: 'cancelada', viewValue: 'Cancelada'},
  ];

  @Output()
  onEdit = new EventEmitter<any>();
  statusGuide: any[] = [
    {value: 'guia_creada', viewValue: 'Guia creada'},
    {value: 'guia_transito', viewValue: 'Guia en transito'},
    {value: 'entregada', viewValue: 'Entregada'},
    {value: 'demorada', viewValue: 'Demorada'},
  ]
  
  constructor(
    private formBuilder: FormBuilder,
    private _httpClient: HttpClient,
    public dialog: MatDialog,
    private devolucionService: DevolucionService,
    private router: Router,
    private snackBar: MatSnackBar,
  ) { }
    
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;
    
  ngAfterViewInit() {
    this.devolucionsDatabase = new DevolucionsDatabase(this._httpClient);
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    this.hacerTabla(this.keywords);
  }

  mostrarCard(){
    if(this.datos_iniciales){
      this.titulo_diff = true;
    }else{
      this.titulo_diff = false;
    }
    this.hay_datos = !this.hay_datos;
  }

  applyFilterDevoluciones(){
    this.hacerTabla(this.keywords);
  }

  hacerTabla(filtros){
    merge(this.sort.sortChange, this.paginator.page, )
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.devolucionsDatabase!.getRepoIssues(
            this.sort.active, this.sort.direction, this.paginator.pageIndex, this.keywords, this.devolucion_status.value, this.statusGuideSelect.value);
        }),
        map(data => {
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total_count;
          if(data.items.length == 0) {
            this.hay_datos = false 
            this.datos_iniciales = false
          }else{
            this.hay_datos = true 
            this.datos_iniciales = true
          }

          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);
  }

  estatus_devolucion(devolucion){
    let status = "";
    console.log(devolucion.status);
    if (devolucion.status != null){ 
      if (devolucion.status == "closed"){
        status = "Cerrada"
      }else if (devolucion.status == "abierta"){
        status = "Abierta"
      }else if(devolucion.status == "pausada"){
        status = "Pausada"
      }else if(devolucion.status == "en_revision"){
        status = "En revisión"
      }else if(devolucion.status == "cancelada"){
        status = "Cancelada"
      }else if(devolucion.status == "en_proceso"){
        status = "En Proceso"
      }
      else{
        status = "Re-abierta"
      }
    }else{
      if (devolucion.status == null && devolucion.fecha_de_llegada == null){
        status = "Abierta"
      }else{
        status = "En proceso"
      }
    }
    return status;
  }

  openDialog(entrada_token) {
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.keywords = filterValue.trim().toLowerCase();
    this.hacerTabla(this.keywords);
  }

  consultarDevolucion(row){
    this.devolucionService.consultarDevolucion(row.entrada_token)
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          const dialog = this.dialog.open(DialogDetDevolucion ,{width:'90vw', height: '90%',disableClose: false ,data: {params: data, seller: row.seller_name, canal: row.canal, shopify_name: row.shopify_name, return_events: row.return_events, devolutionShipment: row.devolution_shipment}});  
          dialog.componentInstance.onEdit.subscribe((data) => {
            this.onEdit.emit(data);
          });
        }
      },
      error => {
    });
  }

  getDate(dateStatusGuide: string){
    if (dateStatusGuide == null){
      return {
        pardedDate: "",
        parsedTime: ""
      };
    }
    
    let date = moment(dateStatusGuide)
    
    return {
      pardedDate: date.format('MMM D, YYYY'),
      parsedTime: date.format('hh:mm:ss A')
    };
  }

  getStatus(row){

    if (!row.group_label_status_mktf){
      return "";
    }

    let dataSplit = row.group_label_status_mktf.split("_");

    return dataSplit.map( split => {
      let firstLetter = split.charAt(0).toUpperCase();
      let rest = split.slice(1);
      return firstLetter + rest;
    }).join(" ");

  }

  applyFilterStatusGuide(){
    this.hacerTabla('');
  }

  changeStatus(row){
    this.loading = true;
    this.devolucionService.changeStatus(row.id, row.status)
    .pipe(first())
    .subscribe(
      data => {
        this.loading = false;
        this.hacerTabla('');
      },
      error => {
        this.loading = false;
        this.snackBar.open("Error al cambiar el status", "OK", {});
      }
    );
  }
}

export class DataTabOrdDatabase {
  constructor(private _httpClient: HttpClient) {}
  
  getRepoIssues(sort: string, order: string, page: number, filtro1: string, filtro2: string, filtro3: string): Observable<EntradabApi> {
    const href = `${environment.apiUrl}/rmsfe/shopi_orders_to_devolucion.json`;
    const requestUrl =
      `${href}?sort=${sort}&order=${order}&page=${page + 1}&keywordsCanal=${filtro1}&keywordsOrden=${filtro2}&keywordsOrdenMKTF=${filtro3}`;
      return this._httpClient.get<EntradabApi>(requestUrl);
  }
}
export interface EntradabApi {
  items: EntradaIssue[];
  total_count: number;
}
export interface EntradaIssue {
  created_at: string;
  number: string;
  state: string;
  title: string;
}  
export class DevolucionDatabaseItems {
  constructor(private _httpClient: HttpClient) {}

  getRepoIssues(filtro: string): Observable<EntradabApi2> {
    const href = `${environment.apiUrl}/rmsfe/listar_items.json`;
    const requestUrl = `${href}?nombre_producto=${filtro}`;
    return this._httpClient.get<EntradabApi2>(requestUrl);
  }
}

export interface EntradabApi2 {
  items: ItemsIssue[];
  total_count: number;
}

export interface ItemsIssue {
  id: number;
  seller_sku: string;
  title: string;
}
@Component({
    selector: 'devolucions-tab-2',
    templateUrl: './devolucions-tab-2.html',
    styleUrls: ['./devolucions.component.scss']
})
export class DevolucionsTab2 implements OnInit {
    displayedColumns: string[] = [
        'canal', 
        'shopify_name',
        'id',
        'cliente',  
        'fulfillment_status',
        'devolver_orden'
    ];
    dataTabOrdDatabase: DataTabOrdDatabase | null;
    data: EntradaIssue[] = [];

    resultsLength = 0;
    isLoadingResults = true;
    isRateLimitReached = false;
    keywordsCanal = "";
    keywordsOrden = "";
    keywordsOrdenMKTF = "";
    hay_datos = true;
    titulo_diff = false;
    spinner = false;
    hidden_data = false;

    //segunda vista
    ord_id_url= '-1';
    itemForm = new FormControl('', [
      Validators.required,
    ]);

    cantidadForm = new FormControl('', [
      Validators.required,
      Validators.min(1),
    ]);

    filterName:string;
    filterCantidad: string;
    breakpoint: number;
    columna1: number;
    columna2: number;
    columna3: number;
    datos_tabla: ProductosDevolucion[] = [];
    displayedColumnsDev = ['sku', 'producto', 'cantidad', 'action'];
    entradaFinal:ProductosDevolucion[] = [];
    keywordsinput = "";
    devolucionDatabaseItems: DevolucionDatabaseItems | null;
    dataItems: ItemsIssue[] = [];
    options: [];
    isLoaResTab = false;
    show_card_gen_gui = false;
    checkInvRec: FormControl;
    guiaDatosForm: FormGroup;
    formsPai: FormControl;
    formCall: FormControl;
    formColonia: FormControl;
    formNumExt: FormControl;
    formNumInt: FormControl;
    formCodPos: FormControl;
    formCiu: FormControl;
    formsEst: FormControl;
    formTel: FormControl;
    formCor: FormControl;
    formPeso: FormControl;
    formLar: FormControl;
    formAnc: FormControl;
    formAlt: FormControl;
    formCusto: FormControl;
    tipoPaqueteList = [];
    formsPaqu: FormControl;
    formsTipoEnvio: FormControl;
    tipo_empaque: "";
    nombre_empaque: "";
    usuario_gen_guia: string;
    toppingList: string[] = [];
    carrierName: FormControl;
    items: Array<{
      id: any;
      title: string;
      seller_sku: string;
      cantidad: number;
      weight: number;
      length: number;
      width: number;
      height: number;
        list_price: number;
    }> = [];

    constructor(
        public dialog: MatDialog,
        private snackBar: MatSnackBar,
        private _httpClient: HttpClient,
        private router: Router,
        private formBuilder: FormBuilder,
        private devolucionService: DevolucionService,
        private authenticationService: AuthenticationService,
        private route: ActivatedRoute,
    ) { 

      this.authenticationService.currentUser.subscribe(x => this.usuario_gen_guia = x);
      if(this.usuario_gen_guia){
        this.usuario_gen_guia = this.usuario_gen_guia['seller_id'];
      }
    }
    
    @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
    @ViewChild(MatSort, {static: false}) sort: MatSort;

    ngOnInit() {
      this.breakpoint = (window.innerWidth <= 599) ? 1 : 6;
      this.columna1 = (window.innerWidth <= 599) ? 1 : 3;
      this.columna2 = (window.innerWidth <= 599) ? 1 : 2;
      this.columna3 = (window.innerWidth <= 599) ? 1 : 1;

      this.devolucionDatabaseItems = new DevolucionDatabaseItems(this._httpClient);
      this.hacerAutcomplete(this.keywordsinput);

      if(this.ord_id_url == '-1'){
        this.ord_id_url = this.route.snapshot.queryParams['order_id'] || '-1';
        this.addItemsOrder();
        this.hidden_data = false;
      }else{
        this.hidden_data = true;
      }

      this.show_card_gen_gui = false;
      this.checkInvRec = new FormControl('', []);
      this.checkInvRec.setValue(false);
      
      this.guiaDatosForm = this.formBuilder.group({
        formsPai: ['', Validators.required],
        formCall: ['', Validators.required],
        formColonia: ['', Validators.required],
        formNumExt: ['', Validators.required],
        formNumInt: [''],
        formCodPos: ['', Validators.required],
        formCiu: ['', Validators.required],
        formsEst: ['', Validators.required],
        formTel: ['', Validators.required],
        formCor:['', [Validators.required, Validators.email]],
        formPeso: ['', Validators.required],
        formLar: ['', Validators.required],
        formAnc: ['', Validators.required],
        formAlt: ['', Validators.required],
        formsPaqu: ['', Validators.required],
        formsTipoEnvio: ['', Validators.required],
        formCusto: ['', Validators.required],
        carrierName: ['', Validators.required],
      });

      this.formsPai = new FormControl('MX', [Validators.required]);
      this.formCall = new FormControl('', [Validators.required]);
      this.formColonia = new FormControl('', [Validators.required]);
      this.formNumExt = new FormControl('', [Validators.required]);
      this.formNumInt = new FormControl('', []);
      this.formCodPos = new FormControl('', [Validators.required]);
      this.formCiu = new FormControl('', [Validators.required]);
      this.formsEst = new FormControl('', [Validators.required]);
      this.formTel = new FormControl('', [Validators.required]);
      this.formCor = new FormControl('', [
        Validators.required,
        Validators.email,
      ]);
      this.formPeso = new FormControl('', [Validators.required]);
      this.formLar = new FormControl('', [Validators.required]);
      this.formAnc = new FormControl('', [Validators.required]);
      this.formAlt = new FormControl('', [Validators.required]);
      this.formsPaqu = new FormControl('', [Validators.required]);
      this.formsTipoEnvio = new FormControl('', [Validators.required]);
      this.formCusto = new FormControl('', [Validators.required]);
      this.carrierName = new FormControl('', [Validators.required]);
    }

    ngDoCheck(){
      if(this.ord_id_url == '-1'){
        this.ord_id_url = this.route.snapshot.queryParams['order_id'] || '-1';
        this.hidden_data = false;
      }else{
        this.hidden_data = true;
      }
    }

    ngAfterViewInit() {
      this.devolucionDatabaseItems = new DevolucionDatabaseItems(this._httpClient);     
      this.dataTabOrdDatabase = new DataTabOrdDatabase(this._httpClient);
      this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
      this.hacerTabla();
    }

    applyFilterCanal(event: Event) {
      const filterValue = (event.target as HTMLInputElement).value;
      this.keywordsCanal = filterValue.trim().toLowerCase();
      this.hacerTabla();
    }
    
    applyFilterOrden(event: Event) {
      const filterValue = (event.target as HTMLInputElement).value;
      this.keywordsOrden = filterValue.trim().toLowerCase();
      this.hacerTabla();
    }
    
    applyFilterOrdenMKTF(event: Event) {
      const filterValue = (event.target as HTMLInputElement).value;
      this.keywordsOrdenMKTF = filterValue.trim().toLowerCase();
      this.hacerTabla();
    }
    
    hacerTabla(){
      merge(this.sort.sortChange, this.paginator.page, )
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.dataTabOrdDatabase!.getRepoIssues(
            this.sort.active, this.sort.direction, this.paginator.pageIndex, this.keywordsCanal, this.keywordsOrden, this.keywordsOrdenMKTF);
        }),
        map(data => {
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total_count;
          
          if(data.items.length == 0) {
            this.hay_datos = false 
          }else{
            this.hay_datos = true 
          }
          
          this.spinner = false;
            return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          this.isRateLimitReached = true;
          this.spinner = false;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);
    }
    
    consultarOrden(order_id){
      this.devolucionService.consultarOrden(order_id)
      .pipe(first())
      .subscribe(
        data => {
          if(data.status == 200){
            this.dialog.open(DialogDet1 ,{width:'90vw', height: '90%',disableClose: false ,data: {params: data}});
          }
        },
        error => {
      });
    }

    generarDevolucionOrden(order){
      if(order.fulfillment_status != "fulfilled"){
        this.snackBar.open("Error, la orden debe tener el estado fulfilled", "OK", {                      
          duration: 5000,
        });
        this.ord_id_url = '-1';
        this.hidden_data = false;
      }else{
        this.router.navigate(['/devoluciones'], { queryParams: { order_id: order.id }});
        this.ord_id_url = order.id;
        this.addItemsOrder();
        this.hidden_data = true;
      }
    }

    //segunda vista
    onResize(event) {
      this.breakpoint = (event.target.innerWidth <= 599) ? 1 : 6;
      this.columna1 = (window.innerWidth <= 599) ? 1 : 3;
      this.columna2 = (window.innerWidth <= 599) ? 1 : 2;
      this.columna3 = (window.innerWidth <= 599) ? 1 : 1;
    }

    getTotalCost() {
      return this.datos_tabla.map(t => t.cantidad).reduce((acc, value) => acc + value, 0);
    }

    deleteRowData(row_obj){
      this.datos_tabla = this.datos_tabla.filter((value,key)=>{
        return value.sku != row_obj.sku;
      });
      this.entradaFinal = this.datos_tabla;
    }

    regresarTabla(){
      this.datos_tabla = [];
      this.entradaFinal = [];
      this.filterName = "";
      this.filterCantidad = "";
      this.isLoaResTab = false;
      this.ord_id_url = '-1';
      this.checkInvRec.setValue(false);
      this.show_card_gen_gui = false;
      this.resetInputsGenGuiRet();
      this.router.navigate(['/devoluciones']);
      this.hidden_data = false;
      this.items = [];
    }

    applyFilterInput(event: Event) {
      const filterValue = (event.target as HTMLInputElement).value;
      this.keywordsinput = filterValue.trim().toLowerCase();
      this.hacerAutcomplete(this.keywordsinput);
    }

    hacerAutcomplete(filtros){
      merge()
      .pipe(
        startWith({}),
        switchMap(() => {
          return this.devolucionDatabaseItems!.getRepoIssues(filtros);
        }),
        map(data => {
          return data.items;
        }),
        catchError(() => {
          return observableOf([]);
        })
      ).subscribe(data => this.dataItems = data);
    }
    
    displayFn(subject){
      if(subject){
        if(subject.seller_sku){
          return subject.seller_sku;
        }else if(subject.title){
          return subject.title;
        }
      }else{
        return undefined;
      }
    }

    validarDatos(){
      if(this.itemForm.invalid || this.cantidadForm.invalid){
        return;
      }
      var elItem = this.itemForm.value;
      if(!elItem){
        return;
      }
      
      this.filterName = "";
      this.filterCantidad = "";
      let producto = elItem.title;
      let item_id = elItem.id;
      let el_seller_sku = elItem.seller_sku;
      if(!(typeof elItem === 'object' && elItem !== null)){
        this.snackBar.open("Debes seleccionar un producto de la lista", "OK", {                      
          duration: 5000,
        });
        return;
      }
      
      if(elItem.bundle > 0){
        this.snackBar.open("Error, no puedes agregar un bundle", "OK", {                      
          duration: 5000,
        });
        return;
      }
      let cantidad = this.cantidadForm.value;
      this.addItem(this.entradaFinal, el_seller_sku, cantidad, producto, item_id);
      this.datos_tabla = this.entradaFinal;
      this.datos_tabla = this.datos_tabla.filter((value,key)=>{
        return value;
      });
      let foundIndex = this.items.findIndex(item => item.id === item_id);
      if (foundIndex !== -1) {
        this.items[foundIndex].cantidad += cantidad;
      } else {
        this.devolucionService.get_information_item_rmsfe(item_id).pipe(first()).subscribe(data => {
          const { id, seller_sku, title, weight, length, width, height, list_price } = data.body.objeto;
          this.items.push({
            id: id,
            title: title,
            seller_sku: seller_sku,
            cantidad: cantidad,
            weight: weight || 0,
            length: length || 0,
            width: width || 0,
            height: height || 0,
            list_price: list_price || 0.0
          })
        });
      };
    }

    addItemsOrder(){
      if(this.ord_id_url != '-1' && !this.isLoaResTab){
        this.isLoaResTab = true;
        this.datos_tabla = [];
        this.entradaFinal = [];
        this.devolucionService.consultarOrden(this.ord_id_url)
        .pipe(first())
        .subscribe(
          data => {
            let items = data["body"]["items"];
            for (let index = 0; index < items.length; index++) {
              this.addItem(this.entradaFinal, items[index].seller_sku, items[index].cantidad, items[index].nombre_producto, items[index].item_id);
            }
            this.items = items.map(item => ({
              id: item.item_id,
              title: item.nombre_producto,
              seller_sku: item.seller_sku,
              cantidad: item.cantidad,
              weight: item.weight,
              length: item.length,
              width: item.width,
              height: item.height,
              list_price: item.list_price
            }));
            this.datos_tabla = this.entradaFinal;
            this.isLoaResTab = true;
          },
          error => {
            this.isLoaResTab = false;
          }
        );
      }
    }
  
    addItem(arr, seller_sku, quantity, titulo, item_id) {
      let { length } = arr;
      let id = length + 1;
      let found = arr.some(el => el.sku === seller_sku);
      if (!found){
        arr.push({sku: seller_sku, producto: titulo, cantidad: quantity, item_id: item_id});
      }else{
        let index = arr.findIndex(x => x.sku === seller_sku);
        arr[index].cantidad = arr[index].cantidad + quantity;
      }
      return arr;
    }

    preguntarGuia(){
      if(this.datos_tabla.length > 0 && this.entradaFinal.length > 0){
        if(this.verificarArreglo(this.datos_tabla) && this.verificarArreglo(this.entradaFinal)){
          const dialogRef = this.dialog.open(Dialog4, {width:'450px', height: 'auto',disableClose: true});
          dialogRef.afterClosed().subscribe(result => {
            if (result == true){
              this.procesarDevolucionOrden();
            }else{
              this.generarGuiaRetorno();
            }
          });
        }else{
          this.snackBar.open("Error, los productos deben tener una cantidad mayor 0", "OK", {                      
            duration: 5000,
          });
        }
      }else{
        this.snackBar.open("Error, debe agregar al menos un producto en la tabla", "OK", {                      
          duration: 5000,
        });
      } 
    }

    procesarDevolucionOrden(){
      this.show_card_gen_gui = false;
      this.resetInputsGenGuiRet();
      const dialogRef2 = this.dialog.open(Dialog2 ,{width:'450px', height: 'auto',disableClose: true ,data: {entrada_final: this.entradaFinal, ord_id_url: this.ord_id_url, checkInvRec: this.checkInvRec.value}});
      dialogRef2.afterClosed().subscribe(result => {

      });    
    }

    verificarArreglo(arr) {
      let valido = true;
      for (let index = 0; index < arr.length; index++) {
        if(arr[index].cantidad <= 0){
          valido = false;
          break;
        }  
      }
      return valido;
    }

    async generarGuiaRetorno(){
      this.show_card_gen_gui = true;
      this.spinner = true;
      this.resetInputsGenGuiRet();
      await this.obtenerDireccion();
      this.spinner = false;    
    }

    resetInputsGenGuiRet(){
      this.formsPai.setValue('MX');
      this.formCall.setValue('');
      this.formColonia.setValue('');
      this.formNumExt.setValue('');
      this.formNumInt.setValue('');
      this.formCodPos.setValue('');
      this.formCiu.setValue('');
      this.formsEst.setValue('');
      this.formTel.setValue(null);
      this.formCor.setValue('');
      this.formPeso.setValue('');
      this.formLar.setValue('');
      this.formAnc.setValue('');
      this.formAlt.setValue('');
      this.tipoPaqueteList = [];
      this.formsPaqu.setValue('');
      this.formsTipoEnvio.setValue('');
      this.tipo_empaque = "";
      this.nombre_empaque = "";
      this.formCusto.setValue('');
      this.toppingList = [];
      this.carrierName.setValue('');

      this.formCall.reset();
      this.formColonia.reset();
      this.formNumExt.reset();
      this.formNumInt.reset();
      this.formCodPos.reset();
      this.formCiu.reset();
      this.formsEst.reset();
      this.formTel.reset();
      this.formCor.reset();
      this.formPeso.reset('');
      this.formLar.reset('');
      this.formAnc.reset('');
      this.formAlt.reset('');
      this.formsPaqu.reset('');
      this.formsTipoEnvio.reset('');
      this.formCusto.reset('');
      this.carrierName.reset('');
    }

    updateToppingList(tipo_envio){
      switch (tipo_envio) {
        case 'CoD_next_day':
          this.toppingList = ['Mas económico'];
        break;
        case 'CoD_same_day':
          this.toppingList = ['Mas económico'];
        break;
        case 'mismo_dia':
          this.toppingList = ['Mas económico', '99m'];
        break;
        case 'dia_siguiente':
          this.toppingList = ['Mas económico', 'Estafeta', 'FedEx', 'Internacional', 'will_call', 'Amazon','DHL', 'MercadoLibre','99m','otro', 'tiui'];
        break;
        case 'economico':
        case 'Economico':
          this.toppingList = ['Mas económico', 'AMPM','Estafeta', 'FedEx', 'Internacional', 'Paquetexpress', 'will_call', 'Amazon','DHL', 'MercadoLibre','99m','otro', 'tiui'];
        break;
      
        default:
        break;
      }
    }

    updateToppingList2(){
      let tipo_envio = this.formsTipoEnvio.value;
      this.updateToppingList(tipo_envio);
    }

    async obtenerDireccion(){
      this.devolucionService.consultarDireccionOrden(this.ord_id_url)
        .pipe(first())
        .subscribe(
          data => {
            if(data["body"]["boxes"]){
              this.tipoPaqueteList = data["body"]["boxes"];
            }

            if(data["body"]["orden"]){
              let orden = data["body"]["orden"];

              this.formsPai.setValue('MX');
              let calle = (orden.calle != null ) ? orden.calle : "";
              this.formCall.setValue(calle);
              let colonia = (orden.colonia != null ) ? orden.colonia : "";
              this.formColonia.setValue(colonia);
              let numExt = (orden.noexterior != null ) ? orden.noexterior : "";
              this.formNumExt.setValue(numExt);
              let numInt = (orden.nointerior != null ) ? orden.nointerior : "";
              this.formNumInt.setValue(numInt);
              let codPos = (orden.codigo_postal != null ) ? orden.codigo_postal : "";
              this.formCodPos.setValue(codPos);
              let ciudad = (orden.ciudad != null ) ? orden.ciudad : "";
              this.formCiu.setValue(ciudad);
              var estado = (orden.estado != null ) ? orden.estado.toUpperCase() : "";
              this.formsEst.setValue(estado);
              let tel = (orden.telefono != null ) ? orden.telefono : "";
              this.formTel.setValue(tel);
              let correo = (orden.correo != null ) ? orden.correo : "";
              this.formCor.setValue(correo);
              let customer = (orden.customer != null ) ? orden.customer : "";
              this.formCusto.setValue(customer);
              
            }

            if(data["body"]["label"]){
              let paquete = data["body"]["label"];
              this.updateToppingList(paquete.tipo_envio);
              let peso = (paquete.peso_envio != null ) ? paquete.peso_envio : "";
              this.formPeso.setValue(peso);
              let largo = (paquete.largo != null ) ? paquete.largo : "";
              this.formLar.setValue(largo);
              let ancho = (paquete.ancho != null ) ? paquete.ancho : "";
              this.formAnc.setValue(ancho);
              let alto = (paquete.alto != null ) ? paquete.alto : "";
              this.formAlt.setValue(alto);
              let nomPaq = (paquete.nombre_empaque != null ) ? paquete.nombre_empaque : "";
              this.formsPaqu.setValue(nomPaq);
              let tipo_envio = (paquete.tipo_envio != null ) ? paquete.tipo_envio : "";
              this.formsTipoEnvio.setValue(tipo_envio.toLowerCase());
              let tipEmp = (paquete.tipo_empaque != null ) ? paquete.tipo_empaque : "";
              this.tipo_empaque = tipEmp;
              let nomEmp = (paquete.nombre_empaque != null ) ? paquete.nombre_empaque : "";
              this.nombre_empaque = nomEmp;
              let carrier_name = (paquete.carrier_name != null ) ? paquete.carrier_name : "";
              this.carrierName.setValue(carrier_name);
            }

          },
          error => {
            this.spinner = false;
          }
        );
    }

    cancelarGenGuia(){
      this.show_card_gen_gui = false;
    }

    updateTipoEmp(){
      let tipo_empa = this.formsPaqu.value;
      if(tipo_empa != null && tipo_empa != "" && tipo_empa != " "){
        for (let index = 0; index < this.tipoPaqueteList.length; index++) {
          if(this.tipoPaqueteList[index].nombre == tipo_empa){
            this.tipo_empaque = this.tipoPaqueteList[index].tipo_empaque;
            this.nombre_empaque = this.tipoPaqueteList[index].nombre;
            let largo = (this.tipoPaqueteList[index].largo != null ) ? this.tipoPaqueteList[index].largo : "";
            this.formLar.setValue(largo);
            let ancho = (this.tipoPaqueteList[index].ancho != null ) ? this.tipoPaqueteList[index].ancho : "";
            this.formAnc.setValue(ancho);
            let alto = (this.tipoPaqueteList[index].alto != null ) ? this.tipoPaqueteList[index].alto : "";
            this.formAlt.setValue(alto);
            break;
          }
        }
      }
    }

    async generarGuia(){
      if(this.datos_tabla.length > 0 && this.entradaFinal.length > 0){
        if(this.verificarArreglo(this.datos_tabla) && this.verificarArreglo(this.entradaFinal)){
          if (this.formsPai.invalid || 
            this.formCall.invalid || 
            this.formColonia.invalid ||
            this.formNumExt.invalid ||
            this.formNumInt.invalid ||
            this.formCodPos.invalid ||
            this.formCiu.invalid ||
            this.formsEst.invalid ||
            this.formTel.invalid ||
            this.formCor.invalid ||
            this.formPeso.invalid ||
            this.formLar.invalid ||
            this.formAnc.invalid ||
            this.formAlt.invalid ||
            this.formsPaqu.invalid ||
            this.formsTipoEnvio.invalid ||
            this.formCusto.invalid ||
            this.carrierName.invalid){
            return;
          }
          this.spinner = true;
          
          var datos_envio = {
            items: this.items,
            orden_id: this.ord_id_url,  
            paquete_info: {
              "tipo_paquete": this.tipo_empaque,
              "asegurado": false,
              "tipo_envio": this.formsTipoEnvio.value,
              "nombre_paquete": this.nombre_empaque,
              "paqueteria": this.carrierName.value
            },  
            paquetes: [
              {
                "largo": this.formLar.value,
                "ancho": this.formAnc.value,
                "alto": this.formAlt.value,
                "peso": this.formPeso.value
              }
            ],
            origen:{
              "estado": this.formsEst.value,
              "colonia": this.formColonia.value,
              "calle": this.formCall.value,
              "no_ext": this.formNumExt.value,
              "no_int": this.formNumInt.value,
              "telefono": this.formTel.value,
              "codigo_postal": this.formCodPos.value,
              "nombre_contacto": this.formCusto.value,
              "email": this.formCor.value,
              "ciudad": this.formCiu.value,
              "pais": "Mexico",
              "codigo_pais": "MX",
              "company": this.formCusto.value
            },
            destino:{
              "estado": "Ciudad de Mexico",
              "colonia": "Naucalpan de Juarez",
              "calle": "Norte",
              "no_ext": "4, Industrial Alce Blanco",
              "no_int": null,
              "telefono": "5564034746",
              "codigo_postal": 53370,
              "nombre_contacto": "MARKETFUL",
              "email": "soporte.fulfillment@zubut.com",
              "ciudad": "Ciudad de Mexico",
              "pais": "Mexico",
              "codigo_pais": "MX",
              "company": "MARKETFUL"
            }
          };
          
          this.devolucionService.generar_guia_devoluciones_api(datos_envio)
            .pipe(first())
            .subscribe(
              async data => {
                if(data.result.status == 200){
                  await this.consultar_status_guia(datos_envio.orden_id);
                }else{
                  this.spinner = false;
                  this.snackBar.open("Error al generar la guía, intente más tarde.", "OK", {
                    duration: 5000,
                  });
                }
              },
              error => {
                this.spinner = false;
              }
            );
        }else{
          this.snackBar.open("Error, los productos deben tener una cantidad mayor 0", "OK", {                      
            duration: 5000,
          });
        }
      }else{
        this.snackBar.open("Error, debe agregar al menos un producto en la tabla", "OK", {                      
          duration: 5000,
        });
      }
    }

    async consultar_status_guia(order_id){
      this.devolucionService.consultar_sta_gui(order_id)
      .pipe(first())
      .subscribe(
        data => {
          if(data["body"]["result"].status == 200){
            var completado = false;
            var any_error = false;
            var datos_guia = null;
            var result_guia = null;
            var nom_paq = null;
            var guia_prepagada = false;
            var text_error = "Error al generar la guía, intente más tarde.";
            var origen = null;
            var destino = null;
            if(data["body"]["result"]["informe_pipeline"].completado){
              if(data["body"]["result"]["guia"]){
                if(data["body"]["result"]["guia"].guia_creada){

                  var isEmpty = Object.keys(data["body"]["result"]["guia"]["crear_guia"]).length === 0;
                  if(!isEmpty){
                    if(data["body"]["result"]["guia"]["crear_guia"].status == 200){
                      completado = true;
                      result_guia = data["body"]["result"]["guia"];
                      datos_guia = data["body"]["result"]["guia"]["crear_guia"];
                      nom_paq = data["body"]["result"]["guia"]["shipping_company"].shipping_company;
                      origen = data["body"]["result"]["guia"]["origen"];
                      destino = data["body"]["result"]["guia"]["destino"];
                      window.open(data["body"]["result"]["guia"]["crear_guia"].url);
                    }else{
                      any_error = true;
                    }
                  }
                }else{
                  var isEmpty = Object.keys(data["body"]["result"]["guia"]["response_status"]).length === 0;
                  if(!isEmpty){
                    if(data["body"]["result"]["guia"]["response_status"].status != 200){
                      text_error = data["body"]["result"]["guia"]["response_status"].message;
                      any_error = true;
                    }
                  }

                  var isEmpty2 = Object.keys(data["body"]["result"]["guia"]["crear_guia"]).length === 0;
                  if(!isEmpty2){
                    if(data["body"]["result"]["guia"]["crear_guia"].status != 200){
                      text_error = data["body"]["result"]["guia"]["crear_guia"].message;
                      any_error = true;
                    }
                  }
                }
              }
            }

            if(any_error){
              this.spinner = false;
              this.snackBar.open(text_error, "OK", {
                duration: 5000,
              });
            }else{
              if(completado){
                this.guardar_datos_devolucion(datos_guia, result_guia, order_id, nom_paq, guia_prepagada, origen, destino);
              }else{
                setTimeout(() => {
                  this.consultar_status_guia(order_id);
                }, 1000);
              }
            }
          }else{
            setTimeout(() => {
							this.consultar_status_guia(order_id);
						}, 1000);
          }
        },
        error => {
          this.spinner = false;
          this.snackBar.open("Error al generar la guía, intente más tarde.", "OK", {
            duration: 5000,
          });
      });
    }

    guardar_datos_devolucion(datos, result_guia, order_id, nom_paq, guia_prepagada, origen, destino){
      this.devolucionService.enviarDevolucion(this.datos_tabla, datos.tracking_number, nom_paq, this.usuario_gen_guia, this.checkInvRec.value, order_id, datos.file_name, guia_prepagada, result_guia["alto"], result_guia["largo"], result_guia["ancho"], result_guia["tipo_envio_final"], result_guia["shipping_platform"], result_guia["peso_reportado"], origen, destino, result_guia["tipo_paquete"], datos.label_transaction_id, datos.costo_guia, result_guia["nombre_paquete"])
      .pipe(first())
      .subscribe(
        data => {
          if(data.status == 200){
            this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
              this.router.navigate(['/devoluciones']);
            });
          }else{
            this.spinner = false;
            this.snackBar.open("Error al guardar los datos, intente más tarde.", "OK", {
              duration: 5000,
            });
          }
        },
        error => {
          this.spinner = false;
          this.snackBar.open("Error al guardar los datos, intente más tarde.", "OK", {
            duration: 5000,
          });
     });
    }
}

export interface ProductosDevolucion {
  sku: string;
  producto: string;
  cantidad: number;
}
@Component({
  selector: 'dialog-1-det',
  templateUrl: './dialog-1-det.html',
  styleUrls: ['./devolucions.component.scss'],
})
export class DialogDet1 {
  params : any;
  usuario: string;
  datos_tabla: ProductosDevolucion[] = []
  displayedColumns = ['sku', 'producto', 'cantidad'];
  order_id: any;
  spinner = false;

  constructor(
    public dialogRef: MatDialogRef<DialogDet1>,
    private authenticationService: AuthenticationService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
    ){
    if(this.data.params){
      this.params = this.data.params.body;
      this.datos_tabla = this.params["items"];
      this.order_id = this.params["orden"]["id"]
      this.datos_tabla = this.datos_tabla.filter((value,key)=>{
        return value;
      });
    }

    this.authenticationService.currentUser.subscribe(x => this.usuario = x);
    if(this.usuario){
      this.usuario = this.usuario['seller_id'];
    }
  }

  ngOnInit(){

  }

  closeDialog() {
    this.dialogRef.close();
  }

}

@Component({
  selector: 'dialog-2',
  templateUrl: './dialog-2.html',
})
export class Dialog2 {

  guiaForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  error: string;
  la_guia: string;
  mensaje_success = false;
  guiaFormGuia: FormControl;
  formPaqueteria: FormControl;
  paqueteriaFormGuia: FormControl;
  spinner = false;
  entrada_token: string;
  entrada_final: object;
  keywords = "";
  otra = false;
  paqueteria: string;
  usuario: string;
  checked = true;
  num_guia: string;
  checkInvRec: false;
  formFile: FormControl;
  fileToUpload: File = null;
  file_name: string;
  btn_disabled = false;

  constructor(
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<Dialog2>,
    private devolucionService: DevolucionService,
    private authenticationService: AuthenticationService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ){
    if(this.data.entrada_final){
      this.entrada_final = this.data.entrada_final;
    }

    if(this.data.checkInvRec){
      this.checkInvRec = this.data.checkInvRec;
    }

    this.authenticationService.currentUser.subscribe(x => this.usuario = x);
    if(this.usuario){
      this.usuario = this.usuario['seller_id'];
    }
  }

  ngOnInit(){
    this.guiaForm = this.formBuilder.group({
      guiaFormGuia: ['', Validators.required],
    });

    this.guiaFormGuia = new FormControl({value: '', disabled: false}, [
      Validators.required,
    ]);

    this.formPaqueteria = new FormControl({value: '', disabled: false}, [
      Validators.required,
    ]);

    this.paqueteriaFormGuia = new FormControl({value: '', disabled: false}, [Validators.required]);
    this.formFile = new FormControl('', );
  }

  seleccionar(){
    if(this.formPaqueteria.value == "otro"){
      this.otra = true;
    }else{
      this.otra = false;
    }
  }

  reload(){
    this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/devoluciones']);
    });
  }

  guardarDevolucion(){
    if (this.guiaFormGuia.invalid || this.formPaqueteria.invalid || (this.otra && this.paqueteriaFormGuia.invalid)){
      return;
    }
    if (this.file_name == null){
      this.file_name = null;
    }
    this.loading = true;
    this.spinner = true;

    this.mensaje_success = true;
    this.loading = false;
    this.spinner = false;

    if(this.otra){
      this.paqueteria = this.paqueteriaFormGuia.value;
    }else{
      this.paqueteria = this.formPaqueteria.value;
    }
    this.num_guia = this.guiaFormGuia.value;
    let guia_prepagada = true;
    let alto = null;
    let largo = null;
    let ancho = null;
    let tipo_envio = null;
    let shipping_platform = null;
    let peso_reportado = null;
    let origen = null;
    let destino = null;
    let tipo_paquete = null;
    let label_transaction_id = null;
    let costo_guia = null;
    let nombre_paquete = null;

    this.devolucionService.enviarDevolucion(this.data.entrada_final, this.num_guia, this.paqueteria, this.usuario, this.checkInvRec, this.data.ord_id_url, this.file_name, guia_prepagada, alto, largo, ancho, tipo_envio, shipping_platform, peso_reportado, origen, destino, tipo_paquete, label_transaction_id, costo_guia, nombre_paquete)
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          this.mensaje_success = true;
          this.loading = false;
          this.spinner = false;
        }else{
          this.error = data.body["message"];
          this.loading = false;
          this.spinner = false;
        }
      },
      error => {
        this.error = error;
        this.loading = false;
        this.spinner = false;
   });
  }

  handleFileInput(files: FileList) {
    this.spinner = true;
    this.btn_disabled = true;
    this.formFile.disable();
    this.fileToUpload = files.item(0);
    this.devolucionService.getUploadURl(this.fileToUpload.type)
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          this.subirAWS(data.body["data"], this.fileToUpload);
        }else{

        }
      },
      error => {
    });
  }

  subirAWS(response, fileToUpload){
    this.devolucionService.subirArchivo(response.url, fileToUpload)
    .pipe(first())
    .subscribe(
      data => {
        this.file_name = response.file_name;
        this.spinner = false;
        this.btn_disabled = false;
        this.formFile.enable();
        this.snackBar.open("La guía se cargó correctamente", "OK", {                      
          duration: 3500,
        });
      },
      error => {
        this.spinner = false;
        this.btn_disabled = false;
        this.formFile.enable();
        this.snackBar.open("Ocurrió un error al cargar la guía, intentelo de nuevo.", "OK", {                      
          duration: 3500,
        });
    });
  }

}

export interface ShowDatDevolucion {
  titulo: string;
  seller_sku: string;
  ean: string;
  cantidad_anunciada: number;
  cantidad_recibida: number;
}

export interface ReturnEvent {
  created_at: string;
  event_name: string;
  client_note: string;
  tracking_number: string;
}

@Component({
  selector: 'dialog-3',
  templateUrl: './dialog-3.html',
  styleUrls: ['./devolucions.component.scss'],
})
export class DialogDetDevolucion {
  params : any;
  usuario: string;
  datos_tabla: ShowDatDevolucion[] = [];
  displayedColumns = ['titulo', 'seller_sku', 'ean', 'upc', 'cantidad_anunciada', 'cantidad_recibida', 'imagenes'];
  progress = false;
  descargar = false;
  entrada_token: string;
  seller: string;
  canal: string;
  shopify_name: string;
  events: ReturnEvent[] = [];
  columnsEvents = ['created_at', 'event_name', 'client_note', 'tracking_number']
  editable: boolean = false;

  esInventarioRechazo: FormControl = new FormControl(false);
  
  @Output()
  onEdit = new EventEmitter()

  constructor(
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<DialogDetDevolucion>,
    private authenticationService: AuthenticationService,
    private router: Router,
    private devolucionService: DevolucionService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
    ){
    if(this.data.params){
      this.params = this.data.params.body;
      this.datos_tabla = this.params["esta_entrada"];
      this.entrada_token = this.params.entrada_list.entrada_token;
      this.datos_tabla = this.datos_tabla.filter((value,key)=>{
        return value;
      });
      this.events = this.data.return_events

      // cancelada, en proceso, closed
      const isOpen = !["cancelada", "en_proceso", "closed"].includes(this.params.entrada_list.status)
      this.editable = isOpen

      this.esInventarioRechazo.setValue(this.params.entrada_list.inventario_rechazo);
    }

    if(this.data.seller){
      this.seller = this.data.seller;
    }

    if(this.data.canal){
      this.canal = this.data.canal;
    }

    if(this.data.shopify_name){
      this.shopify_name = this.data.shopify_name;
    }

    this.authenticationService.currentUser.subscribe(x => this.usuario = x);
    if(this.usuario){
      this.usuario = this.usuario['seller_id'];
    }
  }

  ngOnInit(){
  }

  getTotalCantAnun() {
    return this.datos_tabla.map(t => t.cantidad_anunciada).reduce((acc, value) => acc + value, 0);
  }

  getTotalCantRec() {
    return this.datos_tabla.map(t => t.cantidad_recibida).reduce((acc, value) => acc + value, 0);
  }

  visualizarImagen(file_name){
    this.devolucionService.visualizarImagen(file_name)
    .pipe(first())
    .subscribe(
      data => {
        window.open(data.body.url, '_blank');
      },
      error => {
        this.snackBar.open("Error al visualizar la imagen", "OK", {});
      }
    );
  }

  openImageDialog(devolution_pictures) {
    this.dialog.open(DialogImagenes, {
      disableClose: false,
      data: {devolution_pictures: devolution_pictures},
    });
  }
}

@Component({
  selector: 'dialog-4',
  templateUrl: './dialog-4.html',
})
export class Dialog4 {}

@Component({
  selector: 'dialog-imagenes',
  templateUrl: './dialog-imagenes.html',
  styleUrls: ['./devolucions.component.scss'],
})
export class DialogImagenes {
  devolution_pictures: any;
  displayedColumns = ['nombre', 'accion'];
  constructor(
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<DialogImagenes>,
    private devolucionService: DevolucionService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if(this.data.devolution_pictures.length > 1) {
      this.devolution_pictures = this.data.devolution_pictures;
    };
  }

  visualizarImagen(file_name){
    this.devolucionService.visualizarImagen(file_name)
    .pipe(first())
    .subscribe(
      data => {
        window.open(data.body.url, '_blank');
      },
      error => {
        this.snackBar.open("Error al visualizar la imagen", "OK", {});
      }
    );
  }
}